import type { Job } from '@mairistem/composants';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type MontantSimulation from '../../interfaces/simulation/montantSimulation';

const url = '/api/finances/simulation/montantSimulation';

export const getMontants = (
	params?: URLSearchParams,
): Promise<TemplateRequestGet<MontantSimulation>> =>
	request.get(`${url}?${params?.toString()}`);

export const getMontantsByImputation = (
	params?: URLSearchParams,
): Promise<TemplateRequestGet<MontantSimulation>> =>
	request.get(`${url}/byImputation?${params?.toString()}`);

export const updateMontant = (
	montantSimulation: Partial<MontantSimulation>,
	params?: URLSearchParams,
) =>
	request.put<Partial<MontantSimulation>, MontantSimulation>(
		`${url}/${montantSimulation.identifiant}?${params?.toString()}`,
		montantSimulation,
	);

export const upsertMontant = (data: any) =>
	request.put<any, MontantSimulation>(`${url}/upsertByImputation`, data);

export const upsertDemandeMontant = (data: any) =>
	request.put<any, MontantSimulation>(`${url}/upsertDemandeByImputation`, data);

export const upsertMontants = (identifiantSimulation: number, montants: any) =>
	request.put<unknown, Job>(url, { montants, identifiantSimulation });
